






















































import { Vue, Component, Watch } from 'vue-property-decorator';
import { MarketsApi, SettingsApi } from '@compassdigital/foodworks.ts.sdk';
import MarketOverview from '@/components/Stats/MarketStats/MarketOverview/index.vue';
import SectorStats from '@/components/Stats/MarketStats/SectorStats/index.vue';
import CuisinesStats from '@/components/Stats/MarketStats/CuisinesStats/index.vue';
import MarketStatsDropdown from '@/components/Stats/MarketStats/MarketStatsDropdown/index.vue';
import moment from 'moment';
import StatsUtil from '@/util/StatsUtil';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import ChartUtil from '@/util/ChartUtils';
import ProfileStats from '@/components/Stats/MarketStats/ProfileStats/index.vue';
import CategoryStats from '@/components/Stats/MarketStats/CategoryStats/index.vue';
import _ from 'lodash';

@Component({
  components: {
    MarketOverview,
    SectorStats,
    ProfileStats,
    CuisinesStats,
    MarketStatsDropdown,
    CategoryStats,
  },
})
export default class MarketStats extends Vue {
  public selectDays: string = moment().subtract(7, 'days').format();

  public marketItems: any = [];

  public cuisineItems: any = [];

  public tempMarketItems: any = [];

  public tempCuisineItems: any = [];

  public tempSectorList: any = [];

  public marketCounts: [] = [];

  public marketsArr: any[] = [];

  public cuisinesArr: any[] = [];

  public searchMarket: any = '';

  public sectorValues = new Set<String>();

  public sectorList: any = '';

  public restaurantsList: any = '';

  public unitsList: any = '';

  public categoryList: any = '';

  public marketOverviewFullDateRange: string = '';

  public loading: boolean = false;

  public mounted() {
    this.getSectorList();
    this.getPartnersList();
    this.getUnitsList();
    this.getPartnerCategoryList();
    this.getMarketsOverviewMarketsCuisines();
  }

  @Watch('searchMarket', { immediate: true })
  marketSelected(val: any) {
    this.getFilteredMarkets(val);
  }

  @Watch('selectDays', { immediate: true })
  daysSelected(val: any) {
    if (val) {
      this.marketOverviewFullDateRange = '';
      this.getFilteredMarkets(this.searchMarket);
    }
  }

  @Watch('marketOverviewFullDateRange', { immediate: true })
  timeframeSelected(val: any) {
    if (val) {
      this.getFilteredMarkets(this.searchMarket);
    }
  }

  public async getFilteredMarkets(val: Array<string>) {
    if (val.length > 0) {
      const filteredMarkets = this.marketItems
        .filter((market: any) => val.includes(market.id));
      if (!this.marketOverviewFullDateRange) {
        /* Market overview market filter */
        const countMarket = StatsUtil.getCountMarkets(
          filteredMarkets,
          this.selectDays,
          '',
          false,
        );
        this.tempMarketItems = countMarket.fetchedMarkets;

        /* Cuisine Market Filter */
        if (this.cuisineItems.length > 0) {
          const tempCuisineItems = JSON.parse(JSON.stringify(this.cuisineItems));
          const countCuisine = StatsUtil.getCountCuisinesMarketFiltered(
            this.tempMarketItems,
            tempCuisineItems,
            // this.selectDays,
            // '',
            // false,
          );
          this.tempCuisineItems = countCuisine;
        }

        if (this.sectorList) {
          const mappedSector = await StatsUtil.getSectorListsByMarket(
            val,
            this.selectDays,
            '',
            false,
          );
          if (mappedSector) {
            const { sectorVal, sectorCount } = mappedSector;
            this.sectorList = ChartUtil.planetChartData(sectorVal, sectorCount);
          }
        }

        if (this.restaurantsList) {
          const mappedPartner = await StatsUtil.getPartnerListsByMarket(
            val,
            this.selectDays,
            '',
            false,
          );
          if (mappedPartner) {
            const { partnerStatus, partnersCount } = mappedPartner;
            this.restaurantsList = ChartUtil.planetChartData(partnerStatus, partnersCount);
          }
        }

        if (this.unitsList) {
          const mappedUnits = await StatsUtil.getUnitListsByMarket(
            val,
            this.selectDays,
            '',
            false,
          );
          if (mappedUnits) {
            const { unitStatus, unitsCount } = mappedUnits;
            this.unitsList = ChartUtil.planetChartData(unitStatus, unitsCount);
          }
        }

        if (this.categoryList) {
          const mappedCategories = await StatsUtil.getPartnerCategoryListsByMarket(
            val,
            this.selectDays,
            '',
            false,
          );
          if (mappedCategories) {
            const { status, count } = mappedCategories;
            this.categoryList = ChartUtil.planetChartData(status, count);
          }
        }
      } else {
        const prevDate = moment(this.marketOverviewFullDateRange.split(' - ')[0]).format('YYYY-MM-DD');
        const nextDate = moment(this.marketOverviewFullDateRange.split(' - ')[1]).format('YYYY-MM-DD');

        /* Market Overview market filter */
        const countMarket = StatsUtil.getCountMarkets(
          filteredMarkets,
          prevDate,
          nextDate,
          true,
        );
        this.tempMarketItems = countMarket.fetchedMarkets;

        /* Cuisine market filter */
        if (this.cuisineItems.length > 0) {
          const tempCuisineItems = JSON.parse(JSON.stringify(this.cuisineItems));
          const countCuisine = StatsUtil.getCountCuisinesMarketFiltered(
            this.tempMarketItems,
            tempCuisineItems,
            // prevDate,
            // nextDate,
            // true,
          );
          this.tempCuisineItems = countCuisine;
        }

        if (this.sectorList) {
          const mappedSector = await StatsUtil.getSectorListsByMarket(
            val,
            prevDate,
            nextDate,
            true,
          );
          if (mappedSector) {
            const { sectorVal, sectorCount } = mappedSector;
            this.sectorList = ChartUtil.planetChartData(sectorVal, sectorCount);
          }
        }

        if (this.restaurantsList) {
          const mappedPartner = await StatsUtil.getPartnerListsByMarket(
            val,
            prevDate,
            nextDate,
            true,
          );
          if (mappedPartner) {
            const { partnerStatus, partnersCount } = mappedPartner;
            this.restaurantsList = ChartUtil.planetChartData(partnerStatus, partnersCount);
          }
        }

        if (this.unitsList) {
          const mappedUnits = await StatsUtil.getUnitListsByMarket(
            val,
            prevDate,
            nextDate,
            true,
          );
          if (mappedUnits) {
            const { unitStatus, unitsCount } = mappedUnits;
            this.unitsList = ChartUtil.planetChartData(unitStatus, unitsCount);
          }
        }

        if (this.categoryList) {
          const mappedCategories = await StatsUtil.getPartnerCategoryListsByMarket(
            val,
            prevDate,
            nextDate,
            true,
          );
          if (mappedCategories) {
            const { status, count } = mappedCategories;
            this.categoryList = ChartUtil.planetChartData(status, count);
          }
        }
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (this.marketOverviewFullDateRange) {
        this.onChangeCustomDate(this.marketOverviewFullDateRange.split(' - ')[0],
          this.marketOverviewFullDateRange.split(' - ')[1]);
      } else {
        this.onChangeDays();
      }
    }
  }

  public async getMarketsOverviewMarketsCuisines() {
    this.loading = true;
    const marketsApi = new MarketsApi(AppModule.apiConfig);
    const { data } = await marketsApi.getMarkets();
    if (data) {
      const mappedMarkets = await StatsUtil.getMappedMarketOverviewMarkets(data);
      this.marketItems = mappedMarkets;
      this.tempMarketItems = mappedMarkets;
    }

    await this.getMarketsOverviewCuisines(data);
    await this.onChangeDays();
    await this.accessAdminUser();
    this.loading = false;
  }

  public async getSectorList() {
    const mappedSector = await StatsUtil.getCountSectorLists(this.selectDays, '', false);
    if (mappedSector) {
      const sectorLabel = mappedSector.sectorVal;
      const sectorVal = mappedSector.sectorCount;
      this.sectorList = ChartUtil.planetChartData(sectorLabel, sectorVal);
    }
  }

  public async getPartnersList() {
    const mappedPartner = await StatsUtil.getCountPartnersList(this.selectDays, '', false);
    if (mappedPartner) {
      const { partnerStatus, partnersCount } = mappedPartner;
      this.restaurantsList = ChartUtil.planetChartData(partnerStatus, partnersCount);
    }
  }

  public async getUnitsList() {
    const mappedUnits = await StatsUtil.getCountUnitsList(this.selectDays, '', false);
    if (mappedUnits) {
      const { unitStatus, unitsCount } = mappedUnits;
      this.unitsList = ChartUtil.planetChartData(unitStatus, unitsCount);
    }
  }

  public async getPartnerCategoryList() {
    const mappedPartner = await StatsUtil.getCountPartnerCategoryList(this.selectDays, '', false);
    if (mappedPartner) {
      const { status, count } = mappedPartner;
      this.categoryList = ChartUtil.planetChartData(status, count);
    }
  }

  public async getMarketsOverviewCuisines(markets: any) {
    const cuisinesApi = new SettingsApi(AppModule.apiConfig);
    const { data } = await cuisinesApi.getSettings();
    const mappedCuisines = await StatsUtil
      .getMappedMarketOverviewCuisines(data.cuisineTypes, markets);
    this.cuisineItems = mappedCuisines;
    this.tempCuisineItems = mappedCuisines;
  }

  public async onChangeDays() {
    const nextDate = '';
    this.marketOverviewFullDateRange = '';
    if (this.marketItems.length > 0) {
      const tempMarketItems = JSON.parse(JSON.stringify(this.marketItems));
      const countMarket = StatsUtil.getCountMarkets(
        tempMarketItems,
        this.selectDays,
        nextDate,
        false,
      );
      this.tempMarketItems = countMarket.fetchedMarkets;
    }

    if (this.cuisineItems.length > 0) {
      const tempCuisineItems = JSON.parse(JSON.stringify(this.cuisineItems));
      const countCuisine = StatsUtil.getCountCuisines(
        this.tempMarketItems,
        tempCuisineItems,
      );
      this.tempCuisineItems = countCuisine;
    }

    if (this.sectorList) {
      const mappedSector = await StatsUtil.getCountSectorLists(this.selectDays, nextDate, false);
      if (mappedSector) {
        const { sectorVal, sectorCount } = mappedSector;
        this.sectorList = ChartUtil.planetChartData(sectorVal, sectorCount);
      }
    }

    if (this.restaurantsList) {
      const mappedPartner = await StatsUtil.getCountPartnersList(this.selectDays, nextDate, false);
      if (mappedPartner) {
        const { partnerStatus, partnersCount } = mappedPartner;
        this.restaurantsList = ChartUtil.planetChartData(partnerStatus, partnersCount);
      }
    }

    if (this.unitsList) {
      const mappedUnits = await StatsUtil.getCountUnitsList(this.selectDays, nextDate, false);
      if (mappedUnits) {
        const { unitStatus, unitsCount } = mappedUnits;
        this.unitsList = ChartUtil.planetChartData(unitStatus, unitsCount);
      }
    }

    if (this.categoryList) {
      const mappedCategories = await StatsUtil.getCountPartnerCategoryList(this.selectDays,
        nextDate, false);
      if (mappedCategories) {
        const { status, count } = mappedCategories;
        this.categoryList = ChartUtil.planetChartData(status, count);
      }
    }
    this.marketOverviewFullDateRange = '';
  }

  public async onChangeCustomDate(prevDate: string, NextDate: string) {
    if (this.marketItems.length > 0) {
      const tempMarketItems = JSON.parse(JSON.stringify(this.marketItems));
      const countMarket = await StatsUtil.getCountMarkets(
        tempMarketItems,
        prevDate,
        NextDate,
        true,
      );
      this.tempMarketItems = countMarket.fetchedMarkets;
    }

    if (this.cuisineItems.length > 0) {
      const tempCuisineItems = JSON.parse(JSON.stringify(this.cuisineItems));
      const countCuisine = StatsUtil.getCountCuisines(
        this.tempMarketItems,
        tempCuisineItems,
      );
      this.tempCuisineItems = countCuisine;
    }

    if (this.sectorList) {
      const mappedSector = await StatsUtil.getCountSectorLists(prevDate, NextDate, true);
      if (mappedSector) {
        const { sectorVal, sectorCount } = mappedSector;
        this.sectorList = ChartUtil.planetChartData(sectorVal, sectorCount);
      }
    }

    if (this.restaurantsList) {
      const mappedPartner = await StatsUtil.getCountPartnersList(prevDate, NextDate, true);
      if (mappedPartner) {
        const { partnerStatus, partnersCount } = mappedPartner;
        this.restaurantsList = ChartUtil.planetChartData(partnerStatus, partnersCount);
      }
    }

    if (this.unitsList) {
      const mappedUnits = await StatsUtil.getCountUnitsList(prevDate, NextDate, true);
      if (mappedUnits) {
        const { unitStatus, unitsCount } = mappedUnits;
        this.unitsList = ChartUtil.planetChartData(unitStatus, unitsCount);
      }
    }

    if (this.categoryList) {
      const mappedCategories = await StatsUtil.getCountPartnerCategoryList(prevDate,
        NextDate, true);
      if (mappedCategories) {
        const { status, count } = mappedCategories;
        this.categoryList = ChartUtil.planetChartData(status, count);
      }
    }
  }

  public setCustomDate(prevDate: string, NextDate: string) {
    this.marketOverviewFullDateRange = `${moment(prevDate).format('YYYY-MM-DD')} - ${moment(NextDate).format('YYYY-MM-DD')}`; this.marketOverviewFullDateRange = `${moment(prevDate).format('YYYY-MM-DD')} - ${moment(NextDate).format('YYYY-MM-DD')}`;
  }

  public async accessAdminUser() {
    if (UserModule.currentRole === 'fw_manager' || UserModule.currentRole === 'fw_admin') {
      const marketsArrs = await StatsUtil.acessMarkets();
      if (marketsArrs) {
        this.marketsArr = marketsArrs;
      }
    }
    return null;
  }
}
